import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Edit, Trash2, Mail, Phone, UserPlus, Users, UserCheck, UserX, Search, Download } from 'lucide-react';
import { Button } from '../../components/ui/Button';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Badge } from '../../components/ui/Badge';
import { Input } from '../../components/ui/Input';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '../../components/ui/Table';
import { Avatar, AvatarFallback } from '../../components/ui/Avatar';
export function MemberManagementPage() {
  const navigate = useNavigate();
  const [searchQuery, setSearchQuery] = useState('');
  const members = [{
    id: 1,
    name: 'John Doe',
    email: 'john@example.com',
    phone: '+62 812 3456 7890',
    role: 'Developer',
    status: 'active',
    joinDate: '1 Jan 2024',
    lastActive: '2 jam lalu'
  }, {
    id: 2,
    name: 'Jane Smith',
    email: 'jane@example.com',
    phone: '+62 812 3456 7891',
    role: 'Designer',
    status: 'active',
    joinDate: '15 Jan 2024',
    lastActive: '1 hari lalu'
  }, {
    id: 3,
    name: 'Ahmad Wijaya',
    email: 'ahmad@example.com',
    phone: '+62 812 3456 7892',
    role: 'Developer',
    status: 'active',
    joinDate: '20 Jan 2024',
    lastActive: '3 jam lalu'
  }, {
    id: 4,
    name: 'Siti Nurhaliza',
    email: 'siti@example.com',
    phone: '+62 812 3456 7893',
    role: 'Manager',
    status: 'inactive',
    joinDate: '5 Jan 2024',
    lastActive: '1 minggu lalu'
  }, {
    id: 5,
    name: 'Budi Santoso',
    email: 'budi@example.com',
    phone: '+62 812 3456 7894',
    role: 'Developer',
    status: 'pending',
    joinDate: '25 Jan 2025',
    lastActive: 'Belum aktif'
  }];
  const filteredMembers = members.filter(member => member.name.toLowerCase().includes(searchQuery.toLowerCase()) || member.email.toLowerCase().includes(searchQuery.toLowerCase()) || member.role.toLowerCase().includes(searchQuery.toLowerCase()));
  const stats = [{
    label: 'Total Anggota',
    value: members.length.toString(),
    icon: Users,
    color: 'text-atios-primary',
    bgColor: 'bg-atios-light'
  }, {
    label: 'Anggota Aktif',
    value: members.filter(m => m.status === 'active').length.toString(),
    icon: UserCheck,
    color: 'text-success',
    bgColor: 'bg-success-light'
  }, {
    label: 'Menunggu Approval',
    value: members.filter(m => m.status === 'pending').length.toString(),
    icon: UserPlus,
    color: 'text-warning',
    bgColor: 'bg-warning-light'
  }, {
    label: 'Tidak Aktif',
    value: members.filter(m => m.status === 'inactive').length.toString(),
    icon: UserX,
    color: 'text-neutral-700',
    bgColor: 'bg-neutral-100'
  }];
  const handleDelete = (memberId: number) => {
    if (confirm('Apakah Anda yakin ingin menghapus anggota ini?')) {
      alert(`Anggota #${memberId} berhasil dihapus`);
    }
  };
  const handleApprove = (memberId: number) => {
    alert(`Anggota #${memberId} berhasil disetujui`);
  };
  return <div className="min-h-screen bg-white" data-id="element-4024">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8" data-id="element-4025">
        {/* Header */}
        <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-8" data-id="element-4026">
          <div data-id="element-4027">
            <h1 className="text-3xl font-semibold text-neutral-900 mb-2" data-id="element-4028">
              Kelola Anggota
            </h1>
            <p className="text-neutral-600" data-id="element-4029">Kelola anggota organisasi Anda</p>
          </div>
          <div className="flex gap-3" data-id="element-4030">
            <Button variant="secondary" data-id="element-4031">
              <Download className="w-4 h-4 mr-2" data-id="element-4032" />
              Ekspor Data
            </Button>
            <Button onClick={() => navigate('/members/invite')} data-id="element-4033">
              <Plus className="w-4 h-4 mr-2" data-id="element-4034" />
              Undang Anggota
            </Button>
          </div>
        </div>

        {/* Stats */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8" data-id="element-4035">
          {stats.map((stat, i) => <Card key={i} data-id="element-4036">
              <CardContent className="p-6" data-id="element-4037">
                <div className="flex items-center gap-4" data-id="element-4038">
                  <div className={`p-3 rounded-lg ${stat.bgColor}`} data-id="element-4039">
                    <stat.icon className={`w-6 h-6 ${stat.color}`} data-id="element-4040" />
                  </div>
                  <div data-id="element-4041">
                    <p className="text-2xl font-semibold text-neutral-900" data-id="element-4042">
                      {stat.value}
                    </p>
                    <p className="text-sm text-neutral-600" data-id="element-4043">{stat.label}</p>
                  </div>
                </div>
              </CardContent>
            </Card>)}
        </div>

        {/* Search */}
        <div className="mb-6" data-id="element-4044">
          <div className="relative max-w-md" data-id="element-4045">
            <Search className="absolute left-3 top-1/2 -translate-y-1/2 h-4 w-4 text-neutral-400" data-id="element-4046" />
            <Input placeholder="Cari anggota..." value={searchQuery} onChange={e => setSearchQuery(e.target.value)} className="pl-10" data-id="element-4047" />
          </div>
        </div>

        {/* Members Table */}
        <Card data-id="element-4048">
          <CardHeader data-id="element-4049">
            <CardTitle data-id="element-4050">Daftar Anggota</CardTitle>
          </CardHeader>
          <CardContent data-id="element-4051">
            <Table data-id="element-4052">
              <TableHeader data-id="element-4053">
                <TableRow data-id="element-4054">
                  <TableHead data-id="element-4055">Anggota</TableHead>
                  <TableHead data-id="element-4056">Kontak</TableHead>
                  <TableHead data-id="element-4057">Role</TableHead>
                  <TableHead data-id="element-4058">Status</TableHead>
                  <TableHead data-id="element-4059">Bergabung</TableHead>
                  <TableHead data-id="element-4060">Terakhir Aktif</TableHead>
                  <TableHead className="text-right" data-id="element-4061">Aksi</TableHead>
                </TableRow>
              </TableHeader>
              <TableBody data-id="element-4062">
                {filteredMembers.map(member => <TableRow key={member.id} data-id="element-4063">
                    <TableCell data-id="element-4064">
                      <div className="flex items-center gap-3" data-id="element-4065">
                        <Avatar size="sm" data-id="element-4066">
                          <AvatarFallback data-id="element-4067">
                            {member.name.split(' ').map(n => n[0]).join('')}
                          </AvatarFallback>
                        </Avatar>
                        <div data-id="element-4068">
                          <p className="font-medium text-neutral-900" data-id="element-4069">
                            {member.name}
                          </p>
                        </div>
                      </div>
                    </TableCell>
                    <TableCell data-id="element-4070">
                      <div className="space-y-1 text-sm" data-id="element-4071">
                        <div className="flex items-center gap-1 text-neutral-600" data-id="element-4072">
                          <Mail className="w-3 h-3" data-id="element-4073" />
                          {member.email}
                        </div>
                        <div className="flex items-center gap-1 text-neutral-600" data-id="element-4074">
                          <Phone className="w-3 h-3" data-id="element-4075" />
                          {member.phone}
                        </div>
                      </div>
                    </TableCell>
                    <TableCell data-id="element-4076">
                      <Badge variant="default" className="text-xs" data-id="element-4077">
                        {member.role}
                      </Badge>
                    </TableCell>
                    <TableCell data-id="element-4078">
                      <Badge variant={member.status === 'active' ? 'success' : member.status === 'pending' ? 'warning' : 'default'} data-id="element-4079">
                        {member.status === 'active' ? 'AKTIF' : member.status === 'pending' ? 'PENDING' : 'TIDAK AKTIF'}
                      </Badge>
                    </TableCell>
                    <TableCell className="text-neutral-600 text-sm" data-id="element-4080">
                      {member.joinDate}
                    </TableCell>
                    <TableCell className="text-neutral-600 text-sm" data-id="element-4081">
                      {member.lastActive}
                    </TableCell>
                    <TableCell className="text-right" data-id="element-4082">
                      <div className="flex justify-end gap-2" data-id="element-4083">
                        {member.status === 'pending' && <Button size="sm" variant="secondary" onClick={() => handleApprove(member.id)} data-id="element-4084">
                            <UserCheck className="w-4 h-4 mr-1" data-id="element-4085" />
                            Setujui
                          </Button>}
                        <Button size="sm" variant="ghost" onClick={() => navigate(`/members/${member.id}/edit`)} data-id="element-4086">
                          <Edit className="w-4 h-4" data-id="element-4087" />
                        </Button>
                        <Button size="sm" variant="ghost" onClick={() => handleDelete(member.id)} className="text-error hover:text-error" data-id="element-4088">
                          <Trash2 className="w-4 h-4" data-id="element-4089" />
                        </Button>
                      </div>
                    </TableCell>
                  </TableRow>)}
              </TableBody>
            </Table>
          </CardContent>
        </Card>

        {/* Info Card */}
        <Card className="mt-8 bg-atios-light border-atios-primary/20" data-id="element-4090">
          <CardContent className="p-6" data-id="element-4091">
            <div className="flex items-start gap-4" data-id="element-4092">
              <Users className="w-6 h-6 text-atios-primary flex-shrink-0 mt-1" data-id="element-4093" />
              <div data-id="element-4094">
                <h3 className="font-semibold text-neutral-900 mb-2" data-id="element-4095">
                  Tips Mengelola Anggota
                </h3>
                <ul className="text-sm text-neutral-700 space-y-1 list-disc list-inside" data-id="element-4096">
                  <li data-id="element-4097">Review dan approve anggota baru secara berkala</li>
                  <li data-id="element-4098">Update role dan status anggota sesuai kebutuhan</li>
                  <li data-id="element-4099">
                    Komunikasikan perubahan kebijakan kepada semua anggota
                  </li>
                  <li data-id="element-4100">Backup data anggota secara rutin</li>
                </ul>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>;
}